import {RewardStatus, UserGameRewardQueryResult} from "../http/protocol";
import {HttpService} from "../http/HttpService";


export class UserRewardService {
    constructor(private http : HttpService) {}

    getRewards() : Promise<UserGameRewardQueryResult>{
        return this.http.post("/user-game-reward/list", { limit : 100, offset : 0, status : RewardStatus.NEW, excludeExpired:true});
    }
    claimReward(rewardId : number) : Promise<{}> {
        return this.http.post("/user-game-reward/claim/" + rewardId, {});
    }

    marAllAsRead() : Promise<{}> {
        return this.http.put("/user-game-reward/mark-all-as-read");
    }


}



